<template>
  <v-layout row justify-center>
    <v-dialog :value="dialog" @input="reset" persistent width="35vmax">
      <v-card>
        <v-card-title class="pa-4">
            <div class="title primary--text">{{$t("screener.seats.booking.support.title")}}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-4">
            <div class="mb-3 subheading">
                <div class="secondary--text text--darken-2 pb-1">{{$t('screener.event.title')}}</div>
                <div class="secondary--text">{{eventTitle}}</div>
            </div>
            <v-textarea
            height="150px"
            outline
            name="booking-query"
            label="Describe your problem here"
            v-model="query"
            hint="Request email to admin"
            ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
            <v-spacer></v-spacer>
            <v-btn color="" outline @click.stop="reset">{{$t('screener.btn.close')}}</v-btn>
            <v-btn :disabled="!query" color="primary background--text" outline @click.stop="confirm">{{$t("screener.btn.submit")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
    name:"BookingSupport",
    props:{
        dialog:{
            type:Boolean,
            defaul:false
        },
        eventTitle:{
            type:String,
            defaul:null
        }
    },
    data(){
        return{
            query: null
        }
    },
    watch:{
        query(){
            this.$emit("update:query",this.query)
        }
    },
    methods:{
        reset() {
            this.query = null;
            this.$emit("reset");
        },
        confirm(){
            this.$emit("onConfirm");
        }
    }
}
</script>

<style>

</style>
